<script setup lang="ts">
import { resolvePageHeading } from "@/utils/pageHeading";

const page = usePage();
const site = useSite();

const heading = computed(() =>
  resolvePageHeading(page.value, site.value),
);
</script>

<template>
  <h1 v-if="heading" class="sr-only">
    {{ heading }}
  </h1>
</template>
